/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Steps } from '@/types';
import { AssistantContext } from '@/contexts';
import {
  TYPE_REGISTRE_BY_TYPE_ACTE,
  URL_SOUS_TYPES_ACTE_DECES,
} from '@/constants';

import InformationsActe from './InformationsActe';
import InformationsEvenementDeces from './InformationsEvenementDeces';

/**
 * Étape 1 « Acte » de l'acte de décès : `INFORMATIONS DE L'ACTE` (réutilisée,
 * paramétrée sur les sous-types de décès) et `INFORMATIONS SUR L'ÉVÉNEMENT`.
 *
 * Le défunt, les parents et le déclarant ont chacun leur étape — même
 * découpage que la reconnaissance, où l'enfant a la sienne.
 */
const StepActeDeces = () => {
  const { data, onChange, errors } = React.useContext(AssistantContext);

  /** Tranche d'erreurs propre à cette étape (clés = `name` des champs) */
  const errorsStep = errors?.[Steps.Acte] ?? {};

  return (
    <div
      className="assistant-step-acte-deces"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25em',
        width: '100%',
      }}
    >
      <InformationsActe
        data={data}
        errors={errorsStep}
        onChange={onChange}
        urlSousTypesActe={URL_SOUS_TYPES_ACTE_DECES}
        typeRegistre={TYPE_REGISTRE_BY_TYPE_ACTE.deces}
        labelSousTypeActe="Sous type de décès"
      />
      <InformationsEvenementDeces
        data={data}
        errors={errorsStep}
        onChange={onChange}
      />
    </div>
  );
};

export default StepActeDeces;
